import React from "react";
import * as S from "./AutoSuggest.styles";
import Icon from "../../../../core-components/IconsSelector";
import AutosuggestCard from "./AutosuggestCard";
interface IAutoSuggest {
  recentSearch: Array<{}>;
  currenLocation: () => void;
  popularLocation: Array<{}>;
  onSourceSelect: (item: any) => void;
  isSouce: boolean;
  cursor: number
  onEnterPress: boolean
  setStopCursorUpdate: (boolean) => {}
}

interface ListingCardParams {
  index            : number
  iconName         : string
  isPopularSearch ?: boolean
  data            ?: any
  item            ?: any
}

const HomeAutoSuggest: React.FC<IAutoSuggest> = ({
  currenLocation = () => {},
  onSourceSelect = () => {},
  recentSearch = [],
  popularLocation = [],
  isSouce = true,
  cursor,
  onEnterPress,
  setStopCursorUpdate
}) => {
  React.useEffect(() => {
    if (cursor === (recentSearch?.length || 0) + (popularLocation?.length || 0)) {
      setStopCursorUpdate(true)
    }
  }, [cursor])

  React.useEffect(() => {
    if (onEnterPress) {
      let selectedItem
      if (cursor === 0) {
        currenLocation()
      } else if (recentSearch?.length && cursor <= recentSearch?.length) {
        selectedItem = isSouce ? recentSearch[cursor - 1]?.source : recentSearch[cursor - 1]?.destination
      } else if (popularLocation?.length) {
        const pointer = recentSearch?.length ? cursor - (recentSearch?.length + 1) : cursor - 1
        selectedItem = popularLocation[pointer]
      }

      if (selectedItem) {
        onSourceSelect(selectedItem)
        setStopCursorUpdate(false)
      }
    }
  }, [onEnterPress])

  const getListingCard = (details : ListingCardParams = {} as ListingCardParams) => {
    const fieldRef = React.useRef<HTMLInputElement>(null);
    React.useEffect(() => {
      if (fieldRef.current) {
        if (!details?.isPopularSearch && cursor === details?.index + 1) {
          fieldRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
          })
        }
        
        if (details?.isPopularSearch && cursor === (recentSearch?.length || 0) + details?.index + 1) {
          fieldRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
          })
        }
      }

    }, [cursor]); 
    return (
      <S.KeyBoardSelectedCard
        selected={details?.isPopularSearch ? cursor === (recentSearch?.length || 0) + details?.index + 1 : cursor === details?.index + 1}
        onClick={() => onSourceSelect(details?.isPopularSearch ? details?.item : details?.data)}
        ref={fieldRef}>
        <AutosuggestCard
          title={details?.isPopularSearch ? details?.item?.description : details?.data?.name}
          subTitle={details?.isPopularSearch ? details?.item?.region : details?.data?.city_name}
          iconName={details?.iconName}
        />
      </S.KeyBoardSelectedCard>
    )
  }
  return (
    <S.AutoSuggest>
      <S.CurrentLocation 
        selected={cursor === 0}
        onClick={() => currenLocation()}>
        <Icon
          name="NavArrowIcon"
          styleProps={{ width: "3rem", height: "3rem" }}
        />
        <S.LocTxt>Use Current Location</S.LocTxt>
      </S.CurrentLocation>
      <ul>
        {(recentSearch?.length && (
          <S.Categories>
            <h4>Recent Searches</h4>
            <ul>
              {recentSearch.map((item, index) => {
                const data = isSouce ? item?.source : item?.destination;
                let iconName = "LocationIcon";
                switch (data.loc_type) {
                  case "airport":
                    iconName = "AirportIcon";
                    break;
                  case "city":
                    iconName = "BuildingIcon";
                    break;
                  default:
                    break;
                }
                
                return getListingCard({index, iconName, data})
              })}
            </ul>
          </S.Categories>
        )) ||
          null}
        {(popularLocation?.length && (
          <S.Categories>
            <h4>Popular Searches</h4>
            <ul>
              {popularLocation.map((item, index) => {
                let iconName = "LocationIcon";
                switch (item?.loc_type) {
                  case "airport":
                    iconName = "AirportIcon";
                    break;
                  case "city":
                    iconName = "BuildingIcon";
                    break;
                  default:
                    break;
                }
                return getListingCard({index, iconName, item, isPopularSearch : true})
              })}
            </ul>
          </S.Categories>
        )) ||
          null}
      </ul>
    </S.AutoSuggest>
  );
};
export default HomeAutoSuggest;
